
import { ObservationDescriptionResponse } from "@/utils/carpass/observation-description-response";
import Vue from "vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>ObservationDescriptionResponse,
			required: true
		}
	},
	methods: {
		close(){
			this.$emit("close");
		}
	},
	i18nEx: {
		componentPrefix: "components.cars"
	}
});
